import React from 'react'
import {
  HashRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from 'react-router-dom'

import SubscriptionTable from './Members/Subscription/SubscriptionTableComponent'
import WODTable from './Workouts/WOD/WODTableComponent'
import WorkoutTable from './Workouts/Workout/WorkoutTableComponent'
import TrainingPlanTable from './Workouts/TrainingPlan/TrainingPlanTableComponent'
import UserInfoDisplay from './Members/UserInfoDisplayComponent'
import Parse from 'parse'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import LoginForm from './LoginFormComponent'
import Workout from './Workouts/Workout/WorkoutComponent'
import AdminWorkout from './Workouts/Workout/AdminWorkoutComponent'
import WOD from './Workouts/WOD/WODComponent'
import TrainingPlan from './Workouts/TrainingPlan/TrainingPlanComponent'
import Emails from './Members/EmailsComponent'
import EquipmentList from './Workouts/Equipment/EquipmentListComponent.js'
import EquipmentDetail from './Workouts/Equipment/EquipmentDetailComponent.js'
import EffortVariationList from './Workouts/EffortVariation/EffortVariationListComponent.js'
import EffortVariationDetail from './Workouts/EffortVariation/EffortVariationDetailComponent.js'
import FeaturedContentTable from './FeaturedContentTableComponent'
import Videos from './Videos/VideosComponent'
import Video from './Videos/VideoComponent'
import TipOfTheDays from './Videos/TipOfTheDayListComponent'
import TipOfTheDay from './Videos/TipOfTheDayComponent'
import DrylandExercises from './Workouts/Dryland/DrylandExercisesComponent'
import DrylandExerciseComponent from './Workouts/Dryland/DrylandExerciseComponent'
import ResetPassword from './Members/ResetPasswordComponent'
import SwimReport from './Members/SwimReportComponent'
import FeaturedVideoTable from './Videos/FeaturedVideoTableComponent'
import ChallengesList from './ChallengesListComponent'
import AchievementsList from './AchivementsListComponent.js'
import AchievementsDetail from './AchivementsDetailComponent.js'
import Challenge from './ChallengeComponent'
import MemberListComponent from './Members/MemberListComponent.js'
import MemberDetailComponent from './Members/MemberDetailComponent.js'
import CompletedWorkoutComponent from './CompletedWorkoutComponent.js'
import CompletedWorkoutListComponent from './CompletedWorkoutListComponent.js'
import SwimLocationsComponent from './SwimLocations/SwimLocationsComponent.js'
import CoachFeedbackListComponent from './CoachFeedbackListComponent.js'
import AIFeedbackList from './AIFeedbackListComponent.js'
import CoachMemoriesListComponent from './CoachMemoriesListComponent.js'
import FitFileDebugComponent from './FitFileDebugComponent.js'
import AppleWatchSessionDebugComponent from './AppleWatchSessionDebugComponent.js'
import SkillLevelDetail from './Workouts/SkillLevel/SkillLevelDetailComponent'
import SkillLevelList from './Workouts/SkillLevel/SkillLevelListComponent'
import AdminPlan from './Workouts/TrainingPlan/AdminPlanComponent'
import Config from './config'
import PageTitle from './pageTitle'
import WebTools from './Tools/WebToolsComponent.js'
import DownloadTool from './Tools/DownloadToolComponent.js'
import SwimCoachConversationList from './Tools/SwimCoachConversationListComponent.js'
import SwimCoachConversationDetail from './Tools/SwimCoachConversationDetailComponent.js'
import GenWorkout from './Workouts/genWorkout/GenWorkoutComponent.js'
import GenPlan from './Workouts/genPlan/GenPlanComponent.js'
import ExperimentList from './Experiments/ExperimentListComponent.js'
import ExperimentDetail from './Experiments/ExperimentDetailComponent.js'
import BrandLogo from './BrandLogoComponent'
import ThemeToggle from './ThemeToggleComponent'

// The top-level menus. Each item is a route link, a { header } or a
// { divider }.
const NAV_MENUS = [
  {
    id: 'navbarDropdownMembers',
    label: 'Members',
    items: [
      { to: '/members', label: 'Members' },
      { divider: true },
      { to: '/emails', label: 'Download Email List' },
      { to: '/passwords', label: 'Password Reset' },
      { to: '/swimreport', label: 'Swim Report' }
    ]
  },
  {
    id: 'navbarDropdownLibrary',
    label: 'Library',
    items: [
      { header: 'Workouts' },
      { to: '/wods', label: 'WODs' },
      { to: '/adminworkouts', label: 'Admin Workouts' },
      { to: '/workouts', label: 'Member Workouts' },
      { to: '/exercises', label: 'Dryland Exercises' },
      { to: '/equipment', label: 'Equipment' },
      { to: '/effortvariation', label: 'Effort Variation' },
      { to: '/skilllevels', label: 'Skill Levels' },
      { to: '/genWorkout', label: '🪄 Workout Generator' },
      { divider: true },
      { header: 'Plans' },
      { to: '/adminplans', label: 'Admin Plans' },
      { to: '/trainingplans', label: 'Member Plans' },
      { to: '/genPlan', label: '🪄 Plan Generator' },
      { divider: true },
      { header: 'Videos' },
      { to: '/videos', label: 'Video Library' },
      { to: '/tipofthedays', label: 'Tip of the Day' }
    ]
  },
  {
    id: 'navbarDropdownActivities',
    label: 'Activities',
    items: [
      { to: '/completedWorkouts', label: 'Completed Workouts' },
      { to: '/swimLocations', label: 'Swim Locations' },
      { divider: true },
      { to: '/fitfiledebug', label: 'Fit File Debugger' },
      { to: '/watchSessionDebug', label: 'Apple Watch Session Debugger' },
      { divider: true },
      { header: 'Awards' },
      { to: '/challenges', label: 'Challenges' },
      { to: '/achievements', label: 'Achievements' }
    ]
  },
  {
    id: 'navbarDropdownCoach',
    label: 'Coach',
    items: [
      { to: '/swimCoachConversations', label: 'Conversations' },
      { to: '/coachFeedback', label: 'Feedback' },
      { to: '/aiFeedback', label: 'AI Feedback' },
      { to: '/coachMemories', label: 'Memories' }
    ]
  },
  {
    id: 'navbarDropdownAdminTools',
    label: 'Admin Tools',
    items: [
      { to: '/webtools', label: 'Web Tools' },
      { to: '/downloadtool', label: 'Download Link Tool' },
      { to: '/experiments', label: 'Experiments' },
      { to: '/featuredcontent', label: 'Feed' }
    ]
  }
]

const LoginFormWithRouter = withRouter(LoginForm)
const WODTableWithRouter = withRouter(WODTable)
const WorkoutTableWithRouter = withRouter(WorkoutTable)
const TrainingPlanTableWithRouter = withRouter(TrainingPlanTable)
const UserInfoDisplayWithRouter = withRouter(UserInfoDisplay)
const FeaturedContentTableWithRouter = withRouter(FeaturedContentTable)
const FeaturedVideoTableWithRouter = withRouter(FeaturedVideoTable)

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute ({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        Parse.User.current() ? children : null
      }
    />
  )
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PublicRoute ({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        (Parse.User.current() == null) ? children : null
      }
    />
  )
}

export default class MainNav extends React.Component {
  constructor (props) {
    Parse.initialize(Config.appId, Config.clientKey)
    Parse.serverURL = Config.serverUrl

    super(props)
    this.state = {
      user: Parse.User.current(),
      currentPage: props.currentPage
    }

    this.handleLogoutButton = this.handleLogoutButton.bind(this)

    console.log('MainNav component loading')
    console.log(Parse.User.current())
  }

  handleLogoutButton = (event) => {
    Parse.User.logOut().then(() => {
      this.setState({
        isLoggedOut: Parse.User.current() == null
      })
    })
  }

  changeEnvironmentToDev = () => {
    Config.setEnvironment('dev')
    window.location.reload(false)
  }

  changeEnvironmentToProd = () => {
    Config.setEnvironment('prod')
    window.location.reload(false)
  }

  // One dropdown entry: a link, a group header, or a divider.
  renderMenuItem = (item, index) => {
    if (item.divider) {
      return <li key={index}><hr className="dropdown-divider" /></li>
    }
    if (item.header) {
      return <li key={index}><h6 className="dropdown-header">{item.header}</h6></li>
    }
    return (
      <li key={index}>
        <Link className="dropdown-item" to={item.to}>{item.label}</Link>
      </li>
    )
  }

  render = () => {
    const isDev = Config.getEnvironment() === 'dev'
    return (
      <Router>
        <div>
          <PageTitle />
          <PrivateRoute>

            <nav className="navbar navbar-expand-lg sticky-top msp-navbar">
              <div className="container">

                <Link className="navbar-brand" to="/">
                  <BrandLogo className="msp-brand-logo" />
                  <span className="msp-brand-tag">Admin</span>
                </Link>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">

                  <ul className="navbar-nav me-auto">
                    {NAV_MENUS.map((menu) => (
                      <li className="nav-item dropdown" key={menu.id}>
                        <button className="nav-link dropdown-toggle" type="button" id={menu.id} data-bs-toggle="dropdown" aria-expanded="false">
                          {menu.label}
                        </button>
                        <ul className="dropdown-menu" aria-labelledby={menu.id}>
                          {menu.items.map((item, index) => this.renderMenuItem(item, index))}
                        </ul>
                      </li>
                    ))}
                  </ul>

                  <div className="d-flex align-items-center gap-2 mt-3 mt-lg-0">
                    <div className="dropdown">
                      <button className={'msp-env-toggle dropdown-toggle' + (isDev ? ' msp-env-dev' : '')} type="button" id="navbarDropdownEnvironment" data-bs-toggle="dropdown" aria-expanded="false" title="Which database the admin reads and writes">
                        {isDev ? '🧪 dev' : 'prod'}
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownEnvironment">
                        <li><button type="button" className="dropdown-item" onClick={this.changeEnvironmentToProd}>Production Database</button></li>
                        <li><button type="button" className="dropdown-item" onClick={this.changeEnvironmentToDev}>Development Database</button></li>
                      </ul>
                    </div>
                    <ThemeToggle />
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.handleLogoutButton}>Logout</button>
                  </div>
                </div>
              </div>
            </nav>

          </PrivateRoute>
          <PrivateRoute path="/workouts/:id" component={Workout} isAdmin={false} />
          <PrivateRoute path="/adminworkouts/:id" component={AdminWorkout} />
          <PrivateRoute path="/challenges/:id" component={Challenge} />
          <PrivateRoute path="/videos/:id" component={Video} />
          <PrivateRoute path="/tipofthedays/:id" component={TipOfTheDay} />
          <PrivateRoute path="/exercises/:id" component={DrylandExerciseComponent} />
          <PrivateRoute path="/equipment/:id" component={EquipmentDetail} />
          <PrivateRoute path="/effortVariation/:id" component={EffortVariationDetail} />
          <PrivateRoute path="/skilllevels/:id" component={SkillLevelDetail} />
          <PrivateRoute path="/wod/:id" component={WOD} isAdmin={true} />
          <PrivateRoute path="/trainingplans/:id" component={TrainingPlan} />
          <PrivateRoute path="/adminplans/:id" component={AdminPlan} />
          <PrivateRoute path="/achievements/:id" component={AchievementsDetail} />
          <PrivateRoute path="/userInfo/:id" component={UserInfoDisplay} />
          <PrivateRoute path="/members/:id" component={MemberDetailComponent} />
          <PrivateRoute path="/completedWorkouts/:id" component={CompletedWorkoutComponent} />
          <PrivateRoute path="/experiments/:id" component={ExperimentDetail} />
          <PrivateRoute path="/fitfiledebug" component={FitFileDebugComponent} />
          <PrivateRoute path="/watchSessionDebug" component={AppleWatchSessionDebugComponent} />
          <PrivateRoute path="/webtools" component={WebTools} />
          <PrivateRoute path="/downloadtool" component={DownloadTool} />
          <PrivateRoute path="/swimCoachConversations/:id" component={SwimCoachConversationDetail} />
          <PrivateRoute exact path="/swimCoachConversations" component={SwimCoachConversationList} />
          <PrivateRoute exact path="/userInfo">
            <UserInfoDisplayWithRouter />
          </PrivateRoute>
          <PrivateRoute exact path="/members">
            <MemberListComponent />
          </PrivateRoute>
          <PrivateRoute exact path="/completedWorkouts" >
            <CompletedWorkoutListComponent />
          </PrivateRoute>
          <PrivateRoute exact path="/coachFeedback" >
            <CoachFeedbackListComponent />
          </PrivateRoute>
          <PrivateRoute exact path="/aiFeedback">
            <AIFeedbackList />
          </PrivateRoute>
          <PrivateRoute exact path="/coachMemories" >
            <CoachMemoriesListComponent />
          </PrivateRoute>
          <PrivateRoute exact path="/swimLocations" >
            <SwimLocationsComponent />
          </PrivateRoute>
          <Route exact path="/heatmap">
            <Redirect to="/swimLocations" />
          </Route>
          <PrivateRoute exact path="/experiments">
            <ExperimentList />
          </PrivateRoute>
          <PrivateRoute exact path="/subscription">
            <SubscriptionTable subscriptions={[]} />
          </PrivateRoute>
          <PrivateRoute exact path="/wods">
            <WODTableWithRouter wods={[]} />
          </PrivateRoute>
          <PrivateRoute exact path="/workouts">
            <WorkoutTableWithRouter workouts={[]} isAdmin={false} />
          </PrivateRoute>
          <PrivateRoute exact path="/adminworkouts" >
            <WorkoutTableWithRouter workouts={[]} isAdmin={true} />
          </PrivateRoute>
          <PrivateRoute exact path="/trainingplans">
            <TrainingPlanTableWithRouter plans={[]} />
          </PrivateRoute>
          <PrivateRoute exact path="/adminplans" >
            <TrainingPlanTableWithRouter isAdmin={true} />
          </PrivateRoute>
          <PrivateRoute exact path="/genWorkout" >
            <GenWorkout />
          </PrivateRoute>
          <PrivateRoute exact path="/genPlan" >
            <GenPlan />
          </PrivateRoute>
          <PrivateRoute exact path="/featuredcontent">
            <FeaturedContentTableWithRouter featuredContent={[]} />
          </PrivateRoute>
          <PrivateRoute exact path="/emails">
            <Emails />
          </PrivateRoute>
          <PrivateRoute exact path="/passwords">
            <ResetPassword />
          </PrivateRoute>
          <PrivateRoute exact path="/swimreport">
            <SwimReport />
          </PrivateRoute>
          <PrivateRoute exact path="/videos">
            <Videos />
          </PrivateRoute>
          <PrivateRoute exact path="/tipofthedays">
            <TipOfTheDays />
          </PrivateRoute>
          <PrivateRoute exact path="/featuredvideos">
            <FeaturedVideoTableWithRouter featuredVideos={[]} />
          </PrivateRoute>
          <PrivateRoute exact path="/exercises">
            <DrylandExercises />
          </PrivateRoute>
          <PrivateRoute exact path="/equipment">
            <EquipmentList />
          </PrivateRoute>
          <PrivateRoute exact path="/effortvariation">
            <EffortVariationList />
          </PrivateRoute>
          <PrivateRoute exact path="/skilllevels">
            <SkillLevelList />
          </PrivateRoute>
          <PrivateRoute exact path="/challenges">
            <ChallengesList />
          </PrivateRoute>
          <PrivateRoute exact path="/achievements">
            <AchievementsList />
          </PrivateRoute>
          <PublicRoute path="/">
            <LoginFormWithRouter />
          </PublicRoute>
        </div>
      </Router>
    )
  }
}
